<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<!-- Answer copy nearly mirrors FaqWhenPayment and FaqAfterAccept -->
<details>
  <summary>What if I accept the offer?<Caret /></summary>
  <p>
    If you accept the offer and connect your bank account, we will confirm your acceptance with the finance company.
    It will take <b>approximately</b> 30-60 days to accept the offer, receive funds from the finance company, and for us
    to deliver the funds to you. We will work to accomplish this as quickly as we can.
  </p>
</details>
